import { getCabinetType } from "./api";
import { appUrls } from "../../staff/utils/urls";
import { mapCabinetTypeToSubdomain } from "../../shared/constants";

const cabinetType = getCabinetType();

export function getCabinetUrl(_cabinetType) {
  const type = _cabinetType || cabinetType;
  const subdomain = mapCabinetTypeToSubdomain[type];

  return `//${subdomain}.${process.env.APP_HOST}/app`;
}

export function getPartnerUrl(category = "", _cabinetType = "") {
  const cabinet = _cabinetType === "auto" ? getCabinetType() : _cabinetType;

  return `//${process.env.PARTNER_HOST}${appUrls[category]}${cabinet}`;
}
